import React, {useState, useEffect, useRef} from 'react';
import Link from 'next/link';
import { useSelector, useDispatch } from 'react-redux';
import {update} from '../login/userSlice';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import styles from '../styles/elements/Form.module.scss';
import leadstyles from '../styles/lead/Lead.module.scss';
import useInputState from '../hooks/forms/useInputState';
import useCheckboxState from '../hooks/forms/useCheckboxState';
import InputMask from 'react-input-mask';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faChevronRight, faEnvelope, faMobileAlt, faSearch, faSpinner} from '@fortawesome/free-solid-svg-icons';
import {Typeahead, ClearButton} from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import axios from 'axios';
import ConsoTermsNotice from './ConsoTermsNotice';
import withFullPopup from '../elements/withFullPopup';
import {AmountField, RadioField, CurrencyField, SelectionField} from '../utils/validation/compare/SearchValidators';
import {AmountZeroField, CNPFieldValidator, ValidDate, CIFFieldValidator} from '../utils/validation/compare/CustomValidators';
import {RoPhoneField, TextOnlyValidator, TextValidator } from '../utils/validation/GeneralValidators';
import { EmailField, TermsField } from '../utils/validation/auth/AuthValidators';
import {FormChecker, ScrollToError} from '../utils/validation/FormValidator';
import { CreditBureauValidator, TotalEmploymentValidator, CurrentEmploymentValidator, IncomeField } from '../utils/validation/LeadValidators';
import ErrorMessage from '../elements/ErrorMessage';
import LoginPromo from './LoginPromo';
import LoginBlock from '../login/LoginBlock';
import BRDPartnerTermsNotice from './BRDPartnerTermsNotice';
import BtTermsNotice from './BtTermsNotice';
import {getLeadFormInitValues, getPayloadLeadState, getFormFromState} from '../utils/general/LeadUtilities';
import * as gtag from '../cookie/lib/gtag';
import ReCAPTCHA from 'react-google-recaptcha';


const LeadForm = (props) => {

    const {fields, provider, editStep, editLeadId, editLeadStatus, defaultAmount, defaultCurrency, defaultTerm, defaultLoanType, defaultBank, defaultFormData, editUserEmail, handleSubscribe, handlePageLoad} = props;
    const isMounted = useRef(null);
    const {contact = {}, financial = {}, product = {}, terms = {}, company = {}, car = {}} = fields;
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();

    const initValidStateValue = {help: '', field: '', error: false};
    const initValidState = {
        loanType: initValidStateValue,
        amount: initValidStateValue,
        currency: initValidStateValue,
        term: initValidStateValue,
        income: initValidStateValue,
        otherInstallments: initValidStateValue,
        firstName: initValidStateValue,
        lastName: initValidStateValue,
        email: initValidStateValue,
        phone: initValidStateValue,
        CNP: initValidStateValue,
        county: initValidStateValue,
        city: initValidStateValue,
        branch: initValidStateValue,
        consoTerms: initValidStateValue,
        brdTerms: initValidStateValue,
        brdPartnerTerms: initValidStateValue,
        cecTerms: initValidStateValue,
        cmgTerms: initValidStateValue,
        birthdate: initValidStateValue,
        btTerms: initValidStateValue,
        creditBureauDelay: initValidStateValue,
        totalEmployment: initValidStateValue,
        currentEmployment: initValidStateValue,
        callingTime: initValidStateValue,
        CUI: initValidStateValue,
        autoMaker: initValidStateValue,
        autoModel: initValidStateValue,
        autoAge: initValidStateValue,
        autoType: initValidStateValue,
        autoPrice: initValidStateValue,
        autoPriceCurrency: initValidStateValue,
        financer: initValidStateValue
    };

    const initValues = getLeadFormInitValues(defaultFormData, defaultLoanType, defaultAmount, defaultTerm, defaultCurrency, defaultBank, fields, getFormFromState(user));
    
    const [isValid, editIsValid] = useState(initValidState);
    const [loanType, editLoanType, resetLoanType] = useInputState(initValues.loanType);
    const [amount, editAmount, resetAmount] = useInputState(initValues.amount);
    const [currency, editCurrency, resetCurrency] = useInputState(initValues.currency);
    const [term, editTerm, resetTerm] = useInputState(initValues.term);
    const [income, editIncome] = useState(initValues.income);
    const [creditBureauDelay, editCreditBureauDelay] = useState(initValues.creditBureauDelay);
    const [totalEmployment, editTotalEmployment] = useState(initValues.totalEmployment);
    const [currentEmployment, editCurrentEmployment] = useState(initValues.currentEmployment);
    const [otherInstallments, editOtherInstallments] = useState(initValues.otherInstallments);
    const [firstName, editFirstName] = useState(initValues.firstName);
    const [lastName, editLastName] = useState(initValues.lastName);
    const [email, editEmail] = useState(initValues.email);
    const [phone, editPhone] = useState(initValues.phone);
    const [CNP, editCNP] = useState(initValues.CNP);
    const [birthdate, editBirthdate] = useState({ value: initValues.birthdate, mask: '99/99/9999'});
    const [county, editCounty] = useState(initValues.county );

    const [cities, editCities] = useState([]);
    const [city, editCity] = useState([]);
    const [branches, editBranches] = useState([]);
    const [branch, editBranch] = useState([]);
    const [isLoadingCity, editIsLoadingCity] = useState(false);
    const [isLoadingBranch, editIsLoadingBranch] = useState(false);
    const [ isLoading, editIsLoading] = useState(false);
    const [ isError, editIsError] = useState(false);
    const recaptchaRef = useRef(null);
    const [captchaToken, editCaptchaToken] = useState(false);
    const [captchaError, editCaptchaError] = useState(false);

    const [consoTerms, editConsoTerms] = useCheckboxState(false);
    const [showConsoTerms, editShowConsoTerms] = useState(false);
    const [subscribe, editSubscribe] = useCheckboxState(false);
    const [showLogin, editShowLogin] = useState(false);

    const [brdTerms, editBrdTerms] = useCheckboxState(false);
    const [brdPartnerTerms, editBrdPartnerTerms] = useCheckboxState(false);
    const [showBRDPartnerTerms, editShowBRDPartnerTerms] = useState(false);

    const [cecTerms, editCecTerms] = useCheckboxState(false);

    const [cmgTerms, editCmgTerms] = useCheckboxState(false);

    const [btTerms, editBtTerms] = useCheckboxState(false);
    const [showBtTerms, editShowBtTerms] = useState(false);
    const [callingTime, editCallingTime] = useState('');

    const [CUI, editCUI, resetCIF] = useInputState('');
    const [autoMaker, editAutoMaker, resetAutoMaker] = useInputState('');
    const [autoModel, editAutoModel, resetAutoModel] = useInputState('');
    const [autoAge, editAutoAge, resetAutoAge] = useInputState('');
    const [autoType, editAutoType, resetAutoType] = useInputState('');
    const [autoPrice, editAutoPrice, resetAutoPrice] = useInputState('');
    const [autoPriceCurrency, editAutoPriceCurrency, resetAutoPriceCurrency] = useInputState('');
    
    const countyInList  = (val) => ( contact.hasOwnProperty('county') && contact.county.options.includes(val));
    const cityInList  = (val) => {return cities.includes(val);}
    const branchInList  = (val) => { return branches.find(item => item.branch == val );}

    const [financer, editFinancer] = useState(initValues.financer);

    useEffect( ()=>{
        isMounted.current = true;
        if (user.status == 'idle') {
            handlePageLoad(true);
        }
        editLeadStatus(false);
        return ()=>{
            isMounted.current = false;
        }
    }, []
    )
  
    useEffect(
        ()=>{
            editIsValid({...isValid, city: initValidStateValue});
            editCity([]);
            getCities();
        }, [county]
    )

    useEffect(
        ()=>{
            if (contact.hasOwnProperty('branch')) {
                editIsValid({...isValid, branch: initValidStateValue});
                getBranches();
            }
        }, [city]
    )

    useEffect( ()=>{
       
        if (user.hasProfile) {
            if (isMounted.current) {
                editShowLogin(false);
                if (user.firstName) { editFirstName(user.firstName);}
                if (user.lastName) {editLastName(user.lastName);}
                if (user.email) { editEmail(user.email);}
                if (user.phone) { editPhone(user.phone);}
                if (user.CNP) { editCNP(user.CNP);}
               
                if (user.county && countyInList(user.county) ) { 
                    editCounty([user.county]);
                }            
                
                if (user.loanProfile) {
                    if (user.loanProfile.income) { editIncome(user.loanProfile.income);}
                    if (user.loanProfile.currentPayments) { editOtherInstallments(user.loanProfile.currentPayments);}
    
                }
            }
               
        }
    }, [user.hasProfile])  
    
    const getCities = async () => {
        if (county.length>0) {
            try {
                editIsLoadingCity(true);
                editCity([]);
                document.getElementById('city').classList.remove('is-valid');
                const url = process.env.NEXT_PUBLIC_API + `/api/lead/form/city/${encodeURI(county)}`;
                const response = await axios({
                    method: 'get',
                    url: url, 
                    params: {
                        product: 'loan',
                        provider: provider,
                    },
                    headers: {'Content-Type': 'application/json'},
                });
                const data = response.data;
              
                if (data.status) {
                    if (isMounted.current) {  
                        editCities(data.fields);
                        if (initValues.city.length>0 && data.fields.includes(initValues.city[0].toUpperCase())) { 
                            editCity(initValues.city);
                        }
                        editIsLoadingCity(false);
                        if (user.isLoggedIn) {
                            if (user.city && data.fields.includes(user.city)) { 
                                editCity([user.city]);
                            }
                        }
                        
                    }
                }
            } catch (err) {
               editIsLoadingCity(false);
            }
        }
    }

    const getBranches = async () => {
        if (city.length>0) {
            try {
                editIsLoadingBranch(true);
                editBranch([]);
                document.getElementById('branch').classList.remove('is-valid');
                const url = process.env.NEXT_PUBLIC_API + `/api/lead/form/branch/${encodeURI(county)}/${encodeURI(city)}`;
                const response = await axios({
                    method: 'get',
                    url: url, 
                    params: {
                        product: 'loan',
                        provider: provider,
                    },
                    headers: {'Content-Type': 'application/json'},
                });
                const data = response.data;
              
                if (data.status) {
                    if (isMounted.current) {  
                        editBranches(data.fields);
                        if (initValues.branch.length>0 && data.fields.find(item => initValues.branch[0] = item.branch)) { 
                            editBranch(initValues.branch);
                        }
                        editIsLoadingBranch(false);
                    }
                }
            } catch (err) {
               editIsLoadingBranch(false);
            }
        }
    }

    //load validation rules for fields
    const ValidationRules = {
        loanType: SelectionField,
        amount: AmountField,
        currency: CurrencyField,
        term: AmountField,
        income: { rule: IncomeField, param: { provider, product: loanType, }},
        otherInstallments: AmountZeroField,
        firstName: {rule: TextOnlyValidator, param: 3},
        lastName: {rule: TextOnlyValidator, param: 3},
        email: EmailField,
        phone: RoPhoneField,
        CNP: {rule: CNPFieldValidator, param:{ minAge: 18, maxAge: 65, provider }},
        county: {rule: SelectionField, 
            param: {options: contact.hasOwnProperty('county') ? contact.county.options : []}},
        city: {rule: SelectionField, param: {options: cities}},
        branch: {rule: SelectionField, param: {options: branches, labelKey: 'branch'}},
        consoTerms: TermsField,
        cecTerms: TermsField,
        cmgTerms: TermsField,
        brdTerms: TermsField,
        brdPartnerTerms: TermsField,
        birthdate: { rule: ValidDate, param: { minAge: 18, maxAge: 65, }},
        btTerms: TermsField,
        creditBureauDelay: {rule: CreditBureauValidator, param: {field: 'creditBureauDelay'}},
        totalEmployment: {rule: TotalEmploymentValidator, param: {field: 'totalEmployment', provider}},
        currentEmployment: {rule: CurrentEmploymentValidator, param: {field: 'currentEmployment', provider}},
        callingTime: SelectionField,
        CUI: CIFFieldValidator,
        autoMaker: {rule: TextValidator, param: 2 },
        autoModel: {rule: TextValidator, param: 2 },
        autoAge: SelectionField,
        autoType: SelectionField,
        autoPrice: AmountField,
        autoPriceCurrency: CurrencyField,
        financer: SelectionField,
    };   

    //blur validation
    const validateFieldOnBlur = (e) => { 
        let value = e.target.value;
        if (e.target.type == 'checkbox') {
            value = e.target.checked;
        }
        let id= e.target.id;

        if (id.indexOf('totalEmployment')> -1){
            id = 'totalEmployment';
        } else if (id.indexOf('currentEmployment')>-1){
            id = 'currentEmployment';
        } else if (id.indexOf('creditBureauDelay')>-1) {
            id = 'creditBureauDelay';
        }
    
        let res;
        if (ValidationRules[id]) {
            
            if (typeof ValidationRules[id] == 'object') {
                res = ValidationRules[id].rule(value, ValidationRules[id].param);
            } else {
                res = ValidationRules[id](value);
            }
            
            if (res.status) {
                if ( (id=='county' && !countyInList(value)) || (id=='city' && !cityInList(value)) || (id=='branch' && !branchInList(value))) {
                    res = {
                        status: false,
                        msg: 'Alege o valoare din listă',
                    }
                }
            }

            editIsValid(
                {  ...isValid, 
                    [id] : {
                        help: res.status ? 'valid-feeback' : 'invalid-feedback',
                        field: res.status ? 'is-valid' : 'is-invalid',
                        error: res.msg
                    }
                }
            );
        }
    }

    const handleEditField = (e) => {
        switch(e.target.name) {
            case 'firstName':
                editFirstName(e.target.value);
                break;
            case 'lastName':
                editLastName(e.target.value);
                break;
            case 'email':
                editEmail(e.target.value);
                break;
            case 'income':
                editIncome(e.target.value);
                break;
            case 'otherInstallments':
                editOtherInstallments(e.target.value);
                break;
            case 'phone':
                editPhone(e.target.value);
                break;
            case 'CNP':
                editCNP(e.target.value);
                break;
            case 'birthdate':
                editBirthdate({value: e.target.value, mask: '99/99/9999'});
                break;
            case 'creditBureauDelay':
                editCreditBureauDelay(e.target.value);
                break;
            case 'totalEmployment':
                editTotalEmployment(e.target.value);
                break;
            case 'currentEmployment':
                editCurrentEmployment(e.target.value);
                break;
            case 'callingTime':
                editCallingTime(e.target.value);
                break;
            case 'financer':
                editFinancer(e.target.value);
                break;
        }
    }

    const financerField = product.hasOwnProperty('financer') &&
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="loanType" >{product.financer.label}</Form.Label>
                <Form.Control as="select" name="financer" id="financer"
                    value={financer}
                    onChange={handleEditField}
                    onBlur={validateFieldOnBlur}
                    className={isValid.financer.field}
                    custom>
                        <option value="" key="choose">selectează</option>
                    {product.financer.options.map( (val, i) =>
                        <option key={i} value={val}>{val}</option>
                    )}
                </Form.Control>
                <Form.Text className={`helper ${isValid.financer.help}`} as="div">
                    {isValid.financer.error}
                </Form.Text>
            </Form.Group>
        </Col>;

    const loanTypeField = 
        product.hasOwnProperty('loanType') &&
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="loanType" >{product.loanType.label}</Form.Label>
                <Form.Control as="select" name="loanType" id="loanType"
                    value={loanType}
                    onChange={editLoanType}
                    onBlur={validateFieldOnBlur}
                    className={isValid.loanType.field}
                    custom>
                        <option value="" key="choose">selectează</option>
                    {product.loanType.options.map( (val, i) =>
                        <option key={i} value={val}>{val}</option>
                    )}
                </Form.Control>
                <Form.Text className={`helper ${isValid.loanType.help}`} as="div">
                    {isValid.loanType.error}
                </Form.Text>
            </Form.Group>
        </Col>;

    const amountField = (product.hasOwnProperty('amount') && product.hasOwnProperty('currency') && loanType!='Card de credit') &&
        <Col xs={12} md={6}>
            <Form.Group>
                <Form.Label htmlFor="amount">{product.amount.label}</Form.Label>
                <InputGroup>      
                    <Form.Control type="number" name="amount" id="amount"
                        value={amount} 
                        onChange={editAmount} 
                        placeholder={product.amount.label}
                        onBlur={validateFieldOnBlur}
                        className={isValid.amount.field}
                    />
                    <Form.Control as="select" name="currency" id="currency"
                        value={currency}
                        onChange={editCurrency}
                        onBlur={validateFieldOnBlur}
                        className={isValid.currency.field}
                    custom >
                        { product.currency.options.map( val =>
                            <option key={val} value={val} >{val}</option>
                        )}
                    </Form.Control>
                <Form.Text className={`helper ${isValid.amount.help}`} as="div">
                    {isValid.amount.error}
                </Form.Text>              
            </InputGroup>
        </Form.Group>
    </Col>;

    const termField = 
        (product.hasOwnProperty('term') && loanType!='Card de credit') &&
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="term" >{product.term.label}</Form.Label>
                <InputGroup> 
                    <Form.Control type="number"
                        name="term" 
                        id="term"
                        value={term}
                        onChange={editTerm}
                        onBlur={validateFieldOnBlur}
                        className={isValid.term.field}
                    />
                    <InputGroup.Text>ani</InputGroup.Text>
                    <Form.Text className={`helper ${isValid.term.help}`} as="div">
                        {isValid.term.error}
                    </Form.Text> 
                </InputGroup> 
                
            </Form.Group>
        </Col>;

    const incomeField = 
        financial.hasOwnProperty('income') &&
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="income" >{financial.income.label}</Form.Label>
                <InputGroup> 
                    <Form.Control 
                        type="number"
                        name="income" 
                        id="income"
                        value={income}
                        onChange={handleEditField}
                        onBlur={validateFieldOnBlur}
                        className={isValid.income.field}
                    />
                    <InputGroup.Text>RON</InputGroup.Text>
                    <Form.Text className={`helper ${isValid.income.help}`} as="div">
                        {isValid.income.error}  
                    </Form.Text> 
                </InputGroup>            
            </Form.Group>
        </Col>;

    const creditBureauDelayField =   
        financial.hasOwnProperty('creditBureauDelay') &&
        <Col xs={12} className={styles.radio}>
            <Row className="pb-3 align-items-center">
                <Form.Label column sm={6}>
                    Ești înscris cu restanțe la Biroul de Credit?
                </Form.Label>
                <Col sm={6} className="d-flex">
                    {financial.creditBureauDelay.options.map( (opt, i) =>
                        <Form.Check 
                            custom
                            key={i}
                            name="creditBureauDelay"
                            id={`creditBureauDelay${i}`}
                            type="radio"
                            value={opt}
                            onChange={handleEditField}
                            onClick={validateFieldOnBlur}
                            checked={creditBureauDelay==opt ? true : false}
                            label={opt}
                            className={`${isValid.creditBureauDelay.field} col-6 col-sm-5`}
                        />
                    )}            
                </Col>
                <Form.Text className={`d-block ps-3 mt-0 helper ${isValid.creditBureauDelay.help}`} as="div">
                {isValid.creditBureauDelay.error}  
                </Form.Text>
            </Row>
        </Col>;

    const totalEmploymentField =   
        financial.hasOwnProperty('totalEmployment') &&
        <Col xs={12} className={styles.radio}>
            <Row className="pb-3">
                <Form.Label column sm={6}>
                    Vechimea totală în câmpul muncii
                </Form.Label>
                <Col sm={6}  className="">
                    {financial.totalEmployment.options.map( (opt, i) =>
                        <Form.Check 
                            custom
                            key={i}
                            name="totalEmployment"
                            id={`totalEmployment${i}`}
                            type="radio"
                            value={opt}
                            onChange={handleEditField}
                            onClick={validateFieldOnBlur}
                            checked={totalEmployment==opt ? true : false}
                            label={opt}
                            className={`${isValid.totalEmployment.field} col-sm-10`}
                        />
                    )}            
                </Col>
                <Form.Text className={`d-block ps-3 mt-0 helper ${isValid.totalEmployment.help}`} as="div">
                    {isValid.totalEmployment.error}  
                </Form.Text>
            </Row>
        </Col>;

    const currentEmploymentField =   
        financial.hasOwnProperty('currentEmployment') &&
        <Col xs={12} className={styles.radio}>
            <Row className="pb-3">
                <Form.Label column sm={6}>
                    Vechimea totală la jobul actual
                </Form.Label>
                <Col sm={6}  className="">
                    {financial.currentEmployment.options.map( (opt, i) =>
                        <Form.Check 
                            custom
                            key={i}
                            name="currentEmployment"
                            id={`currentEmployment${i}`}
                            type="radio"
                            value={opt}
                            onChange={handleEditField}
                            onClick={validateFieldOnBlur}
                            checked={currentEmployment==opt ? true : false}
                            label={opt}
                            className={`${isValid.currentEmployment.field} col-sm-10`}
                        />
                    )}            
                </Col>
                <Form.Text className={`d-block ps-3 mt-0 helper ${isValid.currentEmployment.help}`} as="div">
                    {isValid.currentEmployment.error}  
                </Form.Text>
            </Row>
        </Col>;


    const otherPaymentsField = 
        financial.hasOwnProperty('otherInstallments') &&
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="otherInstallments" >{financial.otherInstallments.label}</Form.Label>
                <InputGroup> 
                    <Form.Control 
                        type="number"
                        name="otherInstallments" 
                        id="otherInstallments"
                        value={otherInstallments}
                        onChange={handleEditField}
                        onBlur={validateFieldOnBlur}
                        className={isValid.otherInstallments.field}
                    />
                    <InputGroup.Text>RON</InputGroup.Text>
                    <Form.Text className={`helper ${isValid.otherInstallments.help}`} as="div">
                        {isValid.otherInstallments.error}  
                    </Form.Text> 
                </InputGroup>     
            </Form.Group>
        </Col>;

    const firstNameField = 
        contact.hasOwnProperty('firstName') &&
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="firstName" >{contact.firstName.label}</Form.Label>
                <Form.Control 
                    name="firstName" 
                    id="firstName"
                    value={firstName}
                    onChange={handleEditField}
                    onBlur={validateFieldOnBlur}
                    className={isValid.firstName.field}
                />
                <Form.Text className={`helper ${isValid.firstName.help}`} as="div">
                    {isValid.firstName.error}  
                </Form.Text> 
            </Form.Group>
        </Col>;

    const lastNameField = 
        contact.hasOwnProperty('lastName') &&
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="lastName" >{contact.lastName.label}</Form.Label>
                <Form.Control 
                    name="lastName" 
                    id="lastName"
                    value={lastName}
                    onChange={handleEditField}
                    onBlur={validateFieldOnBlur}
                    className={isValid.lastName.field}
                />
                <Form.Text className={`helper ${isValid.lastName.help}`} as="div">
                    {isValid.lastName.error}  
                </Form.Text> 
            </Form.Group>
        </Col>;

    const emailField = 
        contact.hasOwnProperty('email') &&
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="email" >{contact.email.label}</Form.Label>
                <InputGroup>
                    <InputGroup.Text>
                        <FontAwesomeIcon icon={faEnvelope} width={16} height={16}/>
                    </InputGroup.Text>
                    <Form.Control 
                        name="email" 
                        id="email"
                        value={email}
                        disabled={user.isLoggedIn ? true : false}
                        onChange={handleEditField}
                        onBlur={validateFieldOnBlur}
                        className={isValid.email.field}
                    />
                    <Form.Text className={`helper ${isValid.email.help}`} as="div">
                        {isValid.email.error} 
                    </Form.Text> 
                </InputGroup>
            </Form.Group>
        </Col>;

    const phoneField = 
        contact.hasOwnProperty('phone') &&
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="phone" >{contact.phone.label}</Form.Label>
                <InputGroup>
                    <InputGroup.Text>
                        <FontAwesomeIcon icon={faMobileAlt} width={16} height={16}/>
                    </InputGroup.Text>
                    <Form.Control 
                        name="phone" 
                        id="phone"
                        value={phone}
                        onChange={handleEditField}
                        onBlur={validateFieldOnBlur}
                        className={isValid.phone.field}
                        type="number"
                    />
                    <Form.Text className={`helper ${isValid.phone.help}`} as="div">
                        {isValid.phone.error}
                    </Form.Text> 
                </InputGroup>
            </Form.Group>
        </Col>;

    const CNPField = 
        contact.hasOwnProperty('CNP') &&
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="CNP" >{contact.CNP.label}</Form.Label>     
                <Form.Control 
                    name="CNP" 
                    id="CNP"
                    value={CNP}
                    onChange={handleEditField}
                    onBlur={validateFieldOnBlur}
                    className={isValid.CNP.field}
                    type="number"
                />
                <Form.Text className={`helper ${isValid.CNP.help}`} as="div">
                    {isValid.CNP.error}
                </Form.Text>       
            </Form.Group>
        </Col>;

    const birthdateField = 
        contact.hasOwnProperty('birthdate') &&
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="CNP" >{contact.birthdate.label}</Form.Label>     
                <InputMask  
                    placeholder="zz/ll/aaaa"
                    type="text" 
                    {...birthdate}
                    name="birthdate"
                    id="birthdate"
                    onChange={handleEditField}
                    onBlur={validateFieldOnBlur}
                    maskChar="_" 
                    className={`form-control ${isValid.birthdate.field}`}
                />
                <Form.Text className={`helper ${isValid.birthdate.help}`} as="div">
                    {isValid.birthdate.error}
                </Form.Text>       
            </Form.Group>
        </Col>;

    const countyField = 
        contact.hasOwnProperty('county') &&
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="county" >{contact.county.label}</Form.Label>    
                <Typeahead 
                    name="county" 
                    id="county"
                    selected={county}
                    onChange={editCounty}
                    options={contact.county.options}
                    placeholder=""
                    emptyLabel="Niciun rezultat"  
                    onBlur = {validateFieldOnBlur}
                    inputProps={
                        { id: 'county', name: 'county' }
                    }
                    className={`${isValid.county.field} ${leadstyles.capital}`}
                >
                    {({onClear, selected}) => (
                        <div className="rbt-aux">
                            {selected.length>0 && <ClearButton onClick={onClear} />}
                            { selected.length == 0  && <FontAwesomeIcon icon={faSearch} width={16} height={16}/>}
                        </div>
                    )}
                </Typeahead>             
                <Form.Text className={`helper ${isValid.county.help}`} as="div">
                    {isValid.county.error}
                </Form.Text>                     
            </Form.Group>
            
        </Col>;

    const cityField = 
        contact.hasOwnProperty('city') &&
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="city" >{contact.city.label}</Form.Label>    
                    <Typeahead 
                        name="city" 
                        id="city"
                        selected={city}
                        onChange={editCity}
                        options={cities}
                        placeholder=""
                        emptyLabel="Niciun rezultat"
                        onBlur={validateFieldOnBlur}
                        inputProps={
                            { id: 'city', name: 'city' }
                        }
                        disabled={county.length==1 ? false : true}
                        className={`${isValid.city.field}  ${leadstyles.capital}`}
                    >  
                     {({onClear, selected}) => (
                        <div className="rbt-aux">
                            {isLoadingCity && <FontAwesomeIcon icon={faSpinner} spin width={16} height={16}/>}
                            {selected.length>0 && <ClearButton onClick={onClear} />}
                            { (selected.length == 0 && cities.length>0) && <FontAwesomeIcon icon={faSearch} width={16} height={16}/>}
                        </div>
                    )}    
                    </Typeahead>
                    <Form.Text className={`helper ${isValid.city.help}`} as="div">
                        {isValid.city.error}
                    </Form.Text>           
                    
            </Form.Group>
        </Col>;

    const branchField = 
        contact.hasOwnProperty('branch') &&
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="branch" >{contact.branch.label}</Form.Label>         
                    <Typeahead 
                        name="branch" 
                        id="branch"
                        selected={branch}
                        onChange={editBranch}
                        options={branches}
                        placeholder={contact.branch.label}
                        emptyLabel="Niciun rezultat"
                        onBlur={validateFieldOnBlur}
                        labelKey="branch"
                        inputProps={
                            { id: 'branch', name: 'branch' }
                        }
                        disabled={city.length==1 ? false : true}
                        className={`${isValid.branch.field} `}
                    > 
                        {({onClear, selected}) => (
                            <div className="rbt-aux">
                                {isLoadingBranch && <FontAwesomeIcon icon={faSpinner} spin width={16} height={16}/>}
                                {selected.length>0 && <ClearButton onClick={onClear} />}
                            </div>
                        )}  
                    </Typeahead>     
                    <Form.Text className={`helper ${isValid.branch.help}`} as="div">
                        {isValid.branch.error.length>0 ? isValid.branch.error : (branch.length>0 ? branch[0].address : '')}
                    </Form.Text>            
            </Form.Group>
        </Col>;

    const callingTimeField = 
        contact.hasOwnProperty('callingTime') &&
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="callingTime" >{contact.callingTime.label}</Form.Label>
                <Form.Control as="select" name="callingTime" id="callingTime"
                    value={callingTime}
                    onChange={handleEditField}
                    onBlur={validateFieldOnBlur}
                    className={isValid.callingTime.field}
                    custom>
                        <option value="" key="choose">selectează</option>
                    {contact.callingTime.options.map( (val, i) =>
                        <option key={i} value={val}>{val}</option>
                    )}
                </Form.Control>
                <Form.Text className={`helper ${isValid.callingTime.help}`} as="div">
                    {isValid.callingTime.error}
                </Form.Text>
            </Form.Group>
        </Col>;

    const closeConsoTerms = () => { editShowConsoTerms(false)}
    const openConsoTerms = (e) => { e.preventDefault(); editShowConsoTerms(true)}
    const consoTermsLabel = <>Sunt de acord cu <span className={leadstyles.textLink} onClick={openConsoTerms}>termenii si conditiile</span> Conso, în vederea transmiterii acestei solicitari</>;
    const consoTermsField = 
        terms.hasOwnProperty('consoTerms') &&
        <Col xs={12} >
            <Form.Group className="">
                <Form.Check type="checkbox" 
                    className={`${styles.checkboxLabel} ${isValid.consoTerms.field}`}
                    checked={consoTerms}
                    onChange={editConsoTerms} 
                    id="consoTerms"
                    name="consoTerms"
                    custom
                    label={consoTermsLabel}
                    onBlur={validateFieldOnBlur}
                />
                <Form.Text className={`helper ${isValid.consoTerms.help}`} as="div">
                    {isValid.consoTerms.error}
                </Form.Text>
            </Form.Group>
        </Col>;
    const ConsoTermsPopup = withFullPopup(ConsoTermsNotice);

    const brdTermsLabel = <>Am înțeles prevederile <Link
        href={`${process.env.NEXT_PUBLIC_ENDAPI}/documente/terms/informare-brd.pdf`}
        target="_blank">notei de informare</Link> și sunt de acord să fiu contactat de BRD</>;
    const brdTermsField = terms.hasOwnProperty('brdTerms') &&
        <Col xs={12} >
            <Form.Group className="">
                <Form.Check type="checkbox" 
                    className={`${styles.checkboxLabel} ${isValid.brdTerms.field}`}
                    checked={brdTerms}
                    onChange={editBrdTerms} 
                    id="brdTerms"
                    name="brdTerms"
                    custom
                    label={brdTermsLabel}
                    onBlur={validateFieldOnBlur}
                />
                <Form.Text className={`helper ${isValid.brdTerms.help}`} as="div">
                    {isValid.brdTerms.error}
                </Form.Text>
            </Form.Group>
        </Col>;

    const closeBRDPartnerTerms = () => { editShowBRDPartnerTerms(false)}
    const openBRDPartnerTerms = (e) => { e.preventDefault(); editShowBRDPartnerTerms(true)}   
    const brdPartnerTermsLabel = <>Sunt de acord ca numele, prenumele, statusul solicitării și valoarea creditului să ne fie comunicate de către BRD în scopul îndeplinirii <span className={leadstyles.textLink} onClick={openBRDPartnerTerms}>relațiilor contractuale</span> dintre Conso și bancă</>;    
    const brdPartnerField = terms.hasOwnProperty('brdPartnerTerms') &&
        <Col xs={12} >
            <Form.Group className="">
                <Form.Check type="checkbox" 
                    className={`${styles.checkboxLabel} ${isValid.brdPartnerTerms.field}`}
                    checked={brdPartnerTerms}
                    onChange={editBrdPartnerTerms} 
                    id="brdPartnerTerms"
                    name="brdPartnerTerms"
                    custom
                    label={brdPartnerTermsLabel}
                    onBlur={validateFieldOnBlur}
                />
                <Form.Text className={`helper ${isValid.brdPartnerTerms.help}`} as="div">
                    {isValid.brdPartnerTerms.error}
                </Form.Text>
            </Form.Group>
        </Col>;
        
    const BRDPartnerTermsPopup = withFullPopup(BRDPartnerTermsNotice);

    const cecTermsLabel = <>Am citit documentul <Link
        href={`${process.env.NEXT_PUBLIC_ENDAPI}/documente/terms/cec_acord_consultare_bc.pdf`}
        target="_blank">Informare prelucrare date în Sistemul Biroului de Credit</Link> și sunt de acord cu prelucrarea datelor în scopurile menționate</>;
    const cecTermsField = terms.hasOwnProperty('cecTerms') &&
        <Col xs={12} >
            <Form.Group className="">
                <Form.Check type="checkbox" 
                    className={`${styles.checkboxLabel} ${isValid.cecTerms.field}`}
                    checked={cecTerms}
                    onChange={editCecTerms} 
                    id="cecTerms"
                    name="cecTerms"
                    custom
                    label={cecTermsLabel}
                    onBlur={validateFieldOnBlur}
                />
                <Form.Text className={`helper ${isValid.cecTerms.help}`} as="div">
                    {isValid.cecTerms.error}
                </Form.Text>
            </Form.Group>
        </Col>;

    const cmgTermsLabel = <>Sunt de acord cu <Link href="https://www.cmgbroker.ro/termeni-si-conditii" target="_blank">termenii si conditiile CMG Broker</Link> în vederea transmiterii acestei solicitari</>;
    const cmgTermsField = terms.hasOwnProperty('cmgTerms') &&
        <Col xs={12} >
            <Form.Group className="">
                <Form.Check type="checkbox" 
                    className={`${styles.checkboxLabel} ${isValid.cmgTerms.field}`}
                    checked={cmgTerms}
                    onChange={editCmgTerms} 
                    id="cmgTerms"
                    name="cmgTerms"
                    custom
                    label={cmgTermsLabel}
                    onBlur={validateFieldOnBlur}
                />
                <Form.Text className={`helper ${isValid.cmgTerms.help}`} as="div">
                    {isValid.cmgTerms.error}
                </Form.Text>
            </Form.Group>
        </Col>;

    const closeBtTerms = () => { editShowBtTerms(false)}
    const openBtTerms = (e) => { e.preventDefault(); editShowBtTerms(true)}   
    const btTermsLabel = <>Am înțeles prevederile <span className={leadstyles.textLink} onClick={openBtTerms}>notei de informare</span> și sunt de acord să fiu contactat de Banca Transilvania</>;    
    const btTermsField = terms.hasOwnProperty('btTerms') &&
        <Col xs={12} >
            <Form.Group className="">
                <Form.Check type="checkbox" 
                    className={`${styles.checkboxLabel} ${isValid.btTerms.field}`}
                    checked={btTerms}
                    onChange={editBtTerms} 
                    id="btTerms"
                    name="btTerms"
                    custom
                    label={btTermsLabel}
                    onBlur={validateFieldOnBlur}
                />
                <Form.Text className={`helper ${isValid.btTerms.help}`} as="div">
                    {isValid.btTerms.error}
                </Form.Text>
            </Form.Group>
        </Col>;
        
    const BtTermsPopup = withFullPopup(BtTermsNotice);

    const subscribeField = 
        <Col xs={12} >
            <Form.Group className="">
                <Form.Check type="checkbox" 
                    className={styles.checkboxLabel}
                    checked={subscribe}
                    onChange={editSubscribe } 
                    id="subscribe"
                    name="subscribe"
                    custom
                    label="Vreau să primesc pe email noutăți despre ofertele financiare de la Conso"
                />
                <Form.Text className="helper" as="div"></Form.Text>
            </Form.Group>
        </Col>;

    const cuiField = 
        company && company.hasOwnProperty('CUI') &&
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="CUI" >{company.CUI.label}</Form.Label>
                <Form.Control 
                    name="CUI" 
                    id="CUI"
                    value={CUI}
                    onChange={editCUI}
                    onBlur={validateFieldOnBlur}
                    className={isValid.CUI.field}
                    type="number"
                />
                <Form.Text className={`helper ${isValid.CUI.help}`} as="div">
                    {isValid.CUI.error}  
                </Form.Text> 
            </Form.Group>
        </Col>;

    const autoMakerField = 
        car && car.hasOwnProperty('autoMaker') &&
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="autoMaker" >{car.autoMaker.label}</Form.Label>
                <Form.Control 
                    name="autoMaker" 
                    id="autoMaker"
                    value={autoMaker}
                    onChange={editAutoMaker}
                    onBlur={validateFieldOnBlur}
                    className={isValid.autoMaker.field}
                />
                <Form.Text className={`helper ${isValid.autoMaker.help}`} as="div">
                    {isValid.autoMaker.error}  
                </Form.Text> 
            </Form.Group>
        </Col>;

    const autoModelField = 
        car && car.hasOwnProperty('autoModel') &&
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="autoMaker" >{car.autoModel.label}</Form.Label>
                <Form.Control 
                    name="autoModel" 
                    id="autoModel"
                    value={autoModel}
                    onChange={editAutoModel}
                    onBlur={validateFieldOnBlur}
                    className={isValid.autoModel.field}
                />
                <Form.Text className={`helper ${isValid.autoModel.help}`} as="div">
                    {isValid.autoModel.error}  
                </Form.Text> 
            </Form.Group>
        </Col>;

    const autoTypeField = 
        car && car.hasOwnProperty('autoType') &&
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="autoType" >{car.autoType.label}</Form.Label>
                <Form.Control as="select" name="autoType" id="autoType"
                    value={autoType}
                    onChange={editAutoType}
                    onBlur={validateFieldOnBlur}
                    className={isValid.autoType.field}
                    custom>
                        <option value="" key="choose">selectează</option>
                    {car.autoType.options.map( (val, i) =>
                        <option key={i} value={val}>{val}</option>
                    )}
                </Form.Control>
                <Form.Text className={`helper ${isValid.autoType.help}`} as="div">
                    {isValid.autoType.error}
                </Form.Text>
            </Form.Group>
        </Col>;

    const autoAgeField = 
        car && car.hasOwnProperty('autoAge') &&
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="autoAge" >{car.autoAge.label}</Form.Label>
                <Form.Control as="select" name="autoAge" id="autoAge"
                    value={autoAge}
                    onChange={editAutoAge}
                    onBlur={validateFieldOnBlur}
                    className={isValid.autoAge.field}
                    custom>
                        <option value="" key="choose">selectează</option>
                    {car.autoAge.options.map( (val, i) =>
                        <option key={i} value={val}>{val}</option>
                    )}
                </Form.Control>
                <Form.Text className={`helper ${isValid.autoAge.help}`} as="div">
                    {isValid.autoAge.error}
                </Form.Text>
            </Form.Group>
        </Col>;

    const autoPriceField = 
        (car && car.hasOwnProperty('autoPrice') && car.hasOwnProperty('autoPriceCurrency') ) &&
        <Col xs={12} md={6}>
            <Form.Group>
                <Form.Label htmlFor="autoPrice">{car.autoPrice.label}</Form.Label>
                <InputGroup>      
                    <Form.Control type="number" name="autoPrice" id="autoPrice"
                        value={autoPrice} 
                        onChange={editAutoPrice} 
                        placeholder={car.autoPrice.label}
                        onBlur={validateFieldOnBlur}
                        className={isValid.autoPrice.field}
                    />
                    <Form.Control as="select" name="autoPriceCurrency" id="autoPriceCurrency"
                        value={autoPriceCurrency}
                        onChange={editAutoPriceCurrency}
                        onBlur={validateFieldOnBlur}
                        className={isValid.autoPriceCurrency.field}
                    custom >
                        { car.autoPriceCurrency.options.map( val =>
                            <option key={val} value={val} >{val}</option>
                        )}
                    </Form.Control>
                <Form.Text className={`helper ${isValid.autoPrice.help}`} as="div">
                    {isValid.autoPrice.error}
                </Form.Text>              
            </InputGroup>
        </Form.Group>
        </Col>;


    const rowStyle = financer ? { display: 'none' } : {};

    const productInfo = 
        <section className="mb-3">
            <p className={`heading3 ${leadstyles.section}`}>Detalii despre creditul dorit</p>
            { financerField &&
            <Row style={rowStyle}>
                {financerField}
            </Row>
            }
            <Row>
                {loanTypeField}
                {amountField}
                {termField}
            </Row>
        </section>;

    const financialInfo = 
        <section className="mb-3">
            <p className={`heading3 ${leadstyles.section}`}>Detalii despre situația ta financiară</p>
            <Row>
                {creditBureauDelayField}
                {totalEmploymentField}
                {currentEmploymentField}
                {incomeField}
                {otherPaymentsField}
            </Row>
        </section>;

    const companyInfo = 
        <section className="mb-3">
            <p className={`heading3 ${leadstyles.section}`}>Detalii despre companie</p>
            <Row>
                {cuiField}
            </Row>
        </section>;

    const carInfo = 
        <section className="mb-3">
            <p className={`heading3 ${leadstyles.section}`}>Detalii despre autovehicul</p>
            <Row>
                {autoPriceField}
                {autoTypeField}
                {autoAgeField}
                {autoMakerField}
                {autoModelField}
            </Row>
        </section>;

    const contactInfo = 
        <section className="mb-3">
            <p className={`heading3 ${leadstyles.section}`}>Date de contact</p>
            <Row>
               {firstNameField}
               {lastNameField}
               {emailField}
               {phoneField}
               {callingTimeField}
               {CNPField}
               {birthdateField}
               {countyField}
               {cityField}
               {branchField}
               
                <Col xs="12">
                    <p className="font-muted heading3">Termeni și condiții</p>
                </Col>
                {btTermsField}
                {showBtTerms && 
                <BtTermsPopup
                        title="INFORMARE PRIVIND PRELUCRAREA SI PROTECTIA DATELOR PERSONALE - BANCA TRANSILVANIA"
                        closePopup={closeBtTerms}
                        goBack={closeBtTerms}
                />}
                {cecTermsField}
                {cmgTermsField}
                {brdTermsField}
                {brdPartnerField}
                {showBRDPartnerTerms && 
                <BRDPartnerTermsPopup
                        title="DE CE AVEM NEVOIE DE ACEST ACCEPT?"
                        closePopup={closeBRDPartnerTerms}
                        goBack={closeBRDPartnerTerms}
                />}
               {consoTermsField}
               {showConsoTerms && 
                <ConsoTermsPopup
                        title="INFORMARE PRIVIND PRELUCRAREA ȘI PROTECȚIA DATELOR PERSONALE"
                        closePopup={closeConsoTerms}
                        goBack={closeConsoTerms}
                        provider={provider}
                />}
              
                {subscribeField}
                {isError &&
                <Col xs={12} className="mb-3">
                    <ErrorMessage title="Eroare" message={isError} />
                </Col>
                }
                <Col xs={12} className="mb-3">
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey="6LfB6dktAAAAAI_blzzzR5fJJA6Ipt0ET7TWrYxj"
                        onChange={(val) => { editCaptchaToken(val); editCaptchaError(false); }}
                    />
                    {captchaError && <div className="helper red">Bifează „Nu sunt robot" pentru a trimite solicitarea.</div>}
                </Col>
                <Col xs={12} >
                    <Button
                    variant="primary"
                    type="submit"
                    disabled={isLoading ? true : false}
                    > 
                    {isLoading ? 
                        <div className="d-flex align-items-center">
                            <Spinner animation="border" className="me-2" /> Te rugăm să aștepți
                        </div>
                        :
                        <>
                            <FontAwesomeIcon icon={faChevronRight} height="16" width="16" className="me-2"/>
                            Trimite
                        </>
                    }
                    </Button>
                </Col>
                
            </Row>
        </section>; 

    const logAnalytics = () => {
        if (window.location.hostname.indexOf('conso.ro')>1) {
            gtag.event('Lead', {
                provider: provider,
                product: loanType,
            });
       } else {
           console.log("beta");
           gtag.event('Lead', {
                provider: provider,
                product: loanType,
            });
       }
    }

    const sendLeadForm = async (e) => {
        e.preventDefault();
        editIsLoading(true);
        editIsError(false);

        if (!captchaToken) {
            editCaptchaError(true);
            editIsError('Bifează „Nu sunt robot" pentru a trimite solicitarea.');
            editIsLoading(false);
            ScrollToError('leadFrm');
            return;
        }

        let validForm = FormChecker('leadFrm', ValidationRules);

        if (validForm.status) {
            let url = process.env.NEXT_PUBLIC_API + `/api/lead/save/${encodeURI(provider)}`;
            const form = document.getElementById('leadFrm');
            const formData = new FormData(form);
            let fields = {};
            for (let pair of formData.entries()) {
                fields[pair[0]] = pair[1];
            }
            if (contact.hasOwnProperty('email')) {
                if (!fields.hasOwnProperty('email')) {
                    fields.email = email;
                } 
            }   
            if (loanType == 'Card de credit') {
                fields.term = 1;
                fields.amount = 1000;
                fields.currency = 'RON';
            }
            fields.captcha = captchaToken;
            try {
                const response = await axios({
                    method: 'post', 
                    url, 
                    data: fields,
                    headers: {'Content-Type': 'application/json'},
                });
                const data = response.data;

                if (isMounted.current) {
                    if (data.status) {
                        let payload = getPayloadLeadState(formData);
                        dispatch(update(payload));
                        editUserEmail(email);
                        editLeadId(data.id);
                        handleSubscribe(data.subscribe);
                        logAnalytics();
                        editStep(data.nextStep);
                        editLeadStatus(data.leadStatus);
                    } else {
                        if (data.hasOwnProperty('error')) {
                            if (typeof data.error === 'string') {
                                editIsError(data.error);
                            } else {
                                let errors = initValidState;
                                for (const prop in data.error) {
                                    if (prop == 'error') {
                                        editIsError('Ups, avem o eroare. Te rugăm să încerci mai târziu.');
                                    } else {
                                        errors[prop] = {
                                            help: 'invalid-feedback',
                                            field: 'is-invalid',
                                            error: data.error[prop]
                                        };
                                        editIsError('Corectează erorile din formular.');
                                    }
                                }
                                editIsValid({ ...isValid, ...errors});
                            }
                            ScrollToError('leadFrm');
                        }
                        // reset captcha — v2 tokens are single-use; retry needs a fresh one
                        if (recaptchaRef.current) { recaptchaRef.current.reset(); }
                        editCaptchaToken(false);
                    }
                }
            } catch(err) {

                if (isMounted.current) {
                    editIsError('Te rugăm să încerci mai târziu');
                    if (recaptchaRef.current) { recaptchaRef.current.reset(); }
                    editCaptchaToken(false);
                }
            }
            if (isMounted.current) {
                editIsLoading(false);
            }
            
        } else {
            editIsValid(validForm.data);
            editIsLoading(false);
            ScrollToError('leadFrm');
        }
    }

    const closeLogin = () => {editShowLogin(false)}

    const LoginScreen = withFullPopup(LoginBlock);


    return (
        <>
            { showLogin && <LoginScreen
                                redirectUrl={false}
                                openAccountLink={false}
                                defaultEmail={email}
                                closePopup={closeLogin}
                                title="Credite Online"
                                lg={6}
                            /> 
            }

            {!user.hasProfile && 
            <div className={`${leadstyles.infoBox} p-3 mb-3 bg-green`}>
                 <LoginPromo goToLogin={editShowLogin} />
            </div>
            }

            { !showLogin &&
            <Form className={styles.root} id="leadFrm" onSubmit={sendLeadForm} >  
                <div className={`${leadstyles.infoBox} p-3 mb-3`}>   
                    {productInfo}
                </div>

                {company && Object.keys(company).length>0 && 
                <div className={`${leadstyles.infoBox} p-3 mb-3`}>
                    { companyInfo}
                </div>
                }

                {car && Object.keys(car).length>0 && 
                <div className={`${leadstyles.infoBox} p-3 mb-3`}>
                    { carInfo}
                </div>
                }

                {Object.keys(financial).length>0 && 
                <div className={`${leadstyles.infoBox} p-3 mb-3`}>
                    { financialInfo}
                </div>
                }

                <div className={`${leadstyles.infoBox} p-3 mb-3`}>
                    {contactInfo}
                </div>
                
            </Form>
            }
        </>
    );
}

export default LeadForm;